import { Navigate, useLocation } from "react-router-dom";

export const AccountRedirect = () => {
  const location = useLocation();

  return (
    <Navigate
      to={{ pathname: "/account", search: location.search }}
      replace
    />
  );
};
